import styled from 'styled-components';

export const CaseReportDatePlaceContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CaseReportDatePlaceBox = styled.div`
  display: flex;
  flex-direction: row;
  gap: 32px;
  margin: 6px 0 0 0;
`;
